// Copyright (c) 2026 Joshua S. Plaza. All rights reserved.

import React from 'react';
import { Box, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import DeveloperCredit from './DeveloperCredit';

const variantStyles = {
  main: { mt: 'auto', py: 2 },
  auth: {
    mt: 1,
    '& .MuiTypography-root': {
      color: alpha('#fff', 0.8),
    },
    '& a': {
      color: '#C5A55A',
      '&:hover': { color: '#D4B96A' },
    },
  },
  public: {
    py: 3,
    textAlign: 'center',
  },
};

const Footer = ({ variant = 'main' }) => {
  const theme = useTheme();

  const baseStyle = variantStyles[variant] || variantStyles.main;

  const sx = variant === 'public'
    ? { ...baseStyle, bgcolor: alpha(theme.palette.background.paper, 0.8) }
    : baseStyle;

  return (
    <Box component="footer" sx={sx}>
      <DeveloperCredit />
    </Box>
  );
};

export default Footer;
